import DropdownNumberMandatory from "./InputComponents/DropdownNumberMandatoryComponent";
import TextNoConfidential from "./InputComponents/TextNoConfidentialComponent";
import CardHeader from "./Utils/CardHeaderComponent";
import React, { useState, useEffect } from "react";
import countriesDropdownValues from "../Utils/CountriesUN";
import TextConfidential from "./InputComponents/TextConfidentialComponent";
import DropdownStringMandatory from "./InputComponents/DropdownStringMandatoryComponent";
import ConfirmationModal from "./Utils/ConfirmationModal";
interface TechnologyProps {
  errors: string[];
  dropdownValues: {
    tab: string;
    inputName: string;
    listValue: string[];
  }[];
  isCBE: boolean;
  status: number;
  data: {
    //set 1
    conversionProcess: string;
    conversionProcessText: string;
    conversionProcessSensitive: boolean;
    //set 2
    trlStart: number | null;
    trlEnd: number | null;

    //set 4 cbe
  };
  handleOnChangeTechology: (e: React.ChangeEvent<any>) => void;
  handleDeleteTechnology: () => void;
}

function Technology({
  isCBE,
  data,
  status,
  handleOnChangeTechology,
  handleDeleteTechnology,
  dropdownValues,
  errors,
}: TechnologyProps) {
  const [isHidden, setIsHidden] = useState(false);
  const toggleVisibility = () => {
    setIsHidden((prevState) => !prevState);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };
  const confirmDelete = () => {
    setIsModalOpen(false);
    handleDeleteTechnology();
  };
  const cancelDelete = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="feedstock-container">
      <CardHeader
        isHidden={isHidden}
        toggleVisibility={toggleVisibility}
        cardName="Technology"
        handleDelete={status == 1 ? handleDeleteClick : null}
        notValid={errors.length > 0}
      />
      {isHidden ? (
        <>
          <div className="form-container">
            <div className="error-container">
              {errors.map((error, index) => (
                <div
                  className="error-text"
                  key={index}
                  style={{ marginBottom: "10px" }}
                >
                  {error}
                </div>
              ))}
            </div>
            <div className="questions-wrapper">
            <div className="question-group-input-first">
              <div className="question-text">Technology / process</div>
              <div className="row">
                <div className="col-12">
                  <DropdownStringMandatory
                    listInputs={
                      dropdownValues.filter(
                        (item) => item.inputName == "conversionProcess"
                      )[0].listValue
                    }
                    label={""}
                    inputName={"conversionProcess"}
                    value={data.conversionProcess}
                    handleOnChange={handleOnChangeTechology}
                    invalidValues={["-", ""]}
                  />
                </div>
                <div className="col-12">
                  <TextConfidential
                    label={
                      "Please provide more details about the selected technology / process"
                    }
                    textValid={
                      data.conversionProcessText.length > 4 ||
                      data.conversionProcess != "Other"
                    }
                    textValue={data.conversionProcessText}
                    textName={"conversionProcessText"}
                    onChange={handleOnChangeTechology}
                    display={
                      data.conversionProcess == "-" ||
                      data.conversionProcess == "" ||
                      data.conversionProcess == "N/A"
                    }
                    isConfidential={data.conversionProcessSensitive}
                    confidentialInputName={"conversionProcessSensitive"}
                  />
                </div>
              </div>
            </div>
            <div
              className={
                data.conversionProcess == "-" ||
                data.conversionProcess == "" ||
                data.conversionProcess == "N/A"
                  ? "hidden-content"
                  : "visible-content"
              }
            >
              <div className="question-group-input">
                <div className="question-text">
                  ‘TRL gain' of the above identified technology/ process
                </div>
                <div className="row">
                  <div className="col-md-6 col-sm-12">
                    <DropdownNumberMandatory
                      listInputs={twoToEight}
                      label={"TRL at project start"}
                      inputName={"trlStart"}
                      value={data.trlStart}
                      handleOnChange={handleOnChangeTechology}
                      alwaysValid={false}
                    />
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <DropdownNumberMandatory
                      listInputs={twoToEight}
                      label={"TRL at project end"}
                      inputName={"trlEnd"}
                      value={data.trlEnd}
                      handleOnChange={handleOnChangeTechology}
                    />
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </>
      ) : null}
      <ConfirmationModal
        isOpen={isModalOpen}
        onRequestClose={cancelDelete}
        onConfirm={confirmDelete}
        title="
        Confirm deletion"
        message="Are you sure you want to delete this component ?"
      />
    </div>
  );
}

export default Technology;
const twoToEight: string[] = ["-"].concat(
  Array.from({ length: 7 }, (_, index) => String(index + 2))
);
